import { getMapFromObject } from '../../../lib'
import type { ErrorCodes, ErrorHandbookCode, ErrorHandbookItem } from './type'

export const createErrorHandbook = (object: ErrorHandbookCode) => {
  return getMapFromObject<ErrorCodes, ErrorHandbookItem>(object)
}
